import { RoutingPaths } from 'app/routes/routes'

export const FilterBarItems = [
  {
    title: 'airlines',
    link: RoutingPaths.avia.filter.aircompany.path(),
  },
  {
    title: 'transfers',
    link: RoutingPaths.avia.filter.transfers.path(),
  },
  // {
  //   title: 'price',
  //   link: RoutingPaths.avia.filter.price.path(),
  // },
  {
    title: 'time',
    link: RoutingPaths.avia.filter.timer.path(),
  },
]
